<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations?.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations?.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-fluid" [formGroup]="globalUserDataForm">

                    <div *ngIf="!isAvailable" class="warning-message">
                        OPCION BLOQUEADA POR MANTENIMIENTO
                    </div>
                    <!-- COORDINATION INPUT FORM -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="translations != null && globalUserDataForm.get('selectedCoordination').value != null">
                        <span>{{ translations.lbl_coordination }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedCoordination').value != null; else noSelectionCoordination">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedCoordination').value || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionCoordination>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- INPUT LANGUAGE
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedLanguage').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_language}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown [options]="languages" formControlName="selectedLanguage" optionLabel="value"
                                [showClear]="true"
                                placeholder="{{translations.lbl_select}} {{translations.lbl_language}}"
                                (onChange)="onChangeUserPreferences()"></p-dropdown>
                        </div>
                    </div> -->

                    <!-- INPUT PERIOD -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedPeriod').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_period}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listStore" [options]="periods" formControlName="selectedPeriod"
                                placeholder="{{lbl_select}} {{lbl_coordination}}" optionLabel="descrip"
                                [showClear]="true" [filter]="true" (onChange)="onChangeUserPreferences()"></p-dropdown>
                        </div>
                    </div>

                    <!-- INPUT TYPE GUIDE 
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedGuide').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_type}} {{translations.lbl_of}}
                                {{translations.lbl_intervener}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listStore" [options]="guides" formControlName="selectedGuide"
                                placeholder="{{translations.lbl_select}} {{translations.lbl_type}} {{translations.lbl_Guide}}"
                                optionLabel="descrip" [showClear]="true" [filter]="true"
                                (onChange)="filterDataAndRefresh()"></p-dropdown>
                        </div>
                    </div> -->
                </div>
            </p-panel>
        </div>
    </div>

    <br />
    <!-- TAB VIEW -->
    <p-tabView>

        <!-- TAB PANEL GUIDES -->
        <p-tabPanel [header]="translations.lbl_coordination_guide_list" [selected]="true">
            <!-- TABLE CONTENT -->
            <p-table emptyMessage="{{translations.lbl_no_records_found}}" #dt2 [columns]="colsGuide" [value]="dataGuide"
                [paginator]="true" [rows]="40" [showCurrentPageReport]="false" [globalFilterFields]="colsGlGuide"
                responsive="true">


                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel"
                                (click)="exportExcel(dataGuide,colsFiGuide,translations.lbl_coordination_guide_list + '_')"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf"
                                (click)="exportPdf(dataGuide,colsFiGuide,translations.lbl_coordination_guide_list + '_')"
                                class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetListGuide()" pTooltip="{{translations.lbl_reload}}"
                                tooltipPosition="bottom"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." /> 
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{ capitalizeLastElement(col.header) }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                        <th *ngIf="dataGuide">{{translations.lbl_select_guide}}</th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                            {{ getNestedValue(rowData, col.field) }}
                        </td>

                        <td>
                            <button pButton pRipple icon="pi pi-search" class="p-button-rounded p-mr-2"
                                [disabled]="!isAvailable"
                                (click)="redirectToLocMatLstM(rowData)"></button>
                        </td>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 1">
                            {{translations.lbl_no_records_found}}
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{dataGuide != null ? dataGuide.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <!-- TAB PANEL SERVS -->
        <p-tabPanel [header]="translations.lbl_registered_workshops_services">
            <!-- TABLE CONTENT -->
            <p-table #dt3 [columns]="colsServ" [value]="dataServ" [paginator]="true" [rows]="40"
                [showCurrentPageReport]="false" [globalFilterFields]="colsGlServ" responsive="true">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel"
                                (click)="exportExcel(dataServ,colsFiServ,translations.lbl_registered_workshops_services+'_')"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf"
                                (click)="exportPdf(dataServ,colsFiServ,translations.lbl_registered_workshops_services+'_')"
                                class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetListServs()" pTooltip="{{translations.lbl_reload}}"
                                tooltipPosition="bottom"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt3.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                            {{ getNestedValue(rowData, col.field) }}
                        </td>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 1">
                            {{translations.lbl_no_records_found}}
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY  -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{dataServ != null ? dataServ.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <!-- TAB PANEL AMOUNT -->
        <p-tabPanel
            [header]="translations.lbl_requests + ' ' + translations.lbl_material + ' ' + translations.lbl_period">
            <p-table #dt4 [columns]="colsAmount" [value]="dataAmount" [paginator]="true" [rows]="40"
                [showCurrentPageReport]="false" [globalFilterFields]="colsGlAmount" responsive="true">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel"
                                (click)="exportExcel(dataAmount,colsFiAmount,translations.lbl_requests + ' ' + translations.lbl_material + ' ' + translations.lbl_period + '_')"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf"
                                (click)="exportPdf(dataAmount,colsFiAmount,translations.lbl_requests + ' ' + translations.lbl_material + ' ' + translations.lbl_period + '_')"
                                class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetListAmount()" pTooltip="{{translations.lbl_reload}}"
                                tooltipPosition="bottom"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt4.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th class="text-right" [pSortableColumn]="col.field">
                                {{ capitalizeLastElement(col.header) }}
                                <p-sortIcon [field]="col.field"></p-sortIcon>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <td class="text-right">
                                {{ getNestedValue(rowData, col.field) }}
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 1">
                            {{translations.lbl_no_records_found}}
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{dataAmount != null && dataAmount.length > 0 ? dataAmount.length
                        - 1 : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <!-- TAB PANEL GUIDE DETAIL -->
        <p-tabPanel
            [header]="translations.lbl_items_requested + ' ' + translations.lbl_in + ' ' + translations.lbl_period">
            <p-table #dt5 [columns]="colsDetailGuide" [value]="dataDetailGuide" [paginator]="true" [rows]="40"
                [showCurrentPageReport]="false" [globalFilterFields]="colsGlDetailGuide" responsive="true">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel"
                                (click)="exportExcel(dataDetailGuide,colsFiDetailGuide,translations.lbl_items_requested + ' ' + translations.lbl_in + ' ' + translations.lbl_period + '_')"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf"
                                (click)="exportPdf(dataDetailGuide,colsFiDetailGuide,translations.lbl_items_requested + ' ' + translations.lbl_in + ' ' + translations.lbl_period+ '_')"
                                class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetGuideDetail()" pTooltip="{{translations.lbl_reload}}"
                                tooltipPosition="bottom"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt5.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th [pSortableColumn]="col.field">
                                {{ capitalizeLastElement(col.header) }}
                                <p-sortIcon [field]="col.field"></p-sortIcon>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <td>
                                {{ getNestedValue(rowData, col.field) }}
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 1">
                            {{translations.lbl_no_records_found}}
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{dataDetailGuide != null ? dataDetailGuide.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</div>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>